// extracted by mini-css-extract-plugin
export default {"tooltipMain":"BPTooltip_tooltipMain__fAn9M","tooltipHover":"BPTooltip_tooltipHover__WVEcu","tooltipHoverTitle":"BPTooltip_tooltipHoverTitle__eCp2W"};